import qs from 'qs';
import moment from 'moment';
import api from './api';
import generateSearchRequest from '../utils/sequelize-search-builder-client';

const selectCompany = (company) => {
	return {
		...company,
		//packagePrice: company.packagePrice ? parseFloat(company.packagePrice) : null,
		createdAt: company.createdAt ? moment(company.createdAt).toDate() : null,
		updatedAt: company.updatedAt ? moment(company.updatedAt).toDate() : null,
	};
};

const selectCompanies = (companies) => companies.map(selectCompany);

class CompanyService {
	async getAll({ page = 0, size = 10, order, filters }) {
		const settings = {
			where: {
				id: {
					as: 'id',
					type: 'like',
				},
				name: {
					as: `name`,
					type: 'like',
				},
				tradingName: {
					as: 'tradingName',
					type: 'like',
				},
				cnpj: {
					as: 'cnpj',
					type: 'like',
				},
				'createdAt:between': {
					as: 'createdAt',
					type: 'between',
				},
			},
			order,
		};
		const request = generateSearchRequest(filters, settings);
		return api
			.get('/companies', {
				paramsSerializer: {
					serialize: (params) => qs.stringify(params, { arrayFormat: 'brackets' }),
				},
				params: {
					page,
					size,
					...request,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectCompanies(data.body) }))
			.catch((error) => {
				console.log(
					'fail when trying to get companies in CompanyService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async get(id) {
		return api
			.get(`/companies/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectCompany)
			.catch((error) => {
				console.log(
					`fail when trying to get company with id ${id} in CompanyService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async create(companyForm) {
		return api
			.post('/companies', companyForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectCompany)
			.catch((error) => {
				console.log(
					'fail when trying to create company in CompanyService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async update(id, companyForm) {
		return api
			.patch(`/companies/${id}`, companyForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectCompany)
			.catch((error) => {
				console.log(
					`fail when trying to update company with id ${id} in CompanyService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async remove(id) {
		return api
			.delete(`/companies/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					`fail when trying to remove company with id ${id} in CompanyService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async hasCompanyWithCnpj(cnpj) {
		return api
			.head(`/companies/cnpj/${cnpj}`)
			.then((response) => true)
			.catch((error) => {
				if (error.response?.status === 404) {
					return false;
				}
				console.log(
					`fail when trying to check if exists company with cnpj ${cnpj} in CompanyService.`,
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}
}

const companyService = new CompanyService();
export default companyService;
